import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { KeyRound } from "lucide-react";
import { api, useAuth } from "../lib/api";
import { Button, Input, Label } from "../components/ui";
import { BrandMark } from "../components/BrandMark";

export default function Login() {
  const { login, refresh } = useAuth();
  const nav = useNavigate();
  const [sp] = useSearchParams();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState(sp.get("sso_error"));
  const [busy, setBusy] = useState(false);
  const [sso, setSso] = useState(null);
  useEffect(() => { api("/auth/oidc/config").then(setSso).catch(() => setSso({ enabled: false })); }, []);
  useEffect(() => {
    if (sp.get("sso") === "ok") { setBusy(true); refresh().then(() => nav(sp.get("next") || "/")).catch(() => { setErr("SSO session could not be established"); setBusy(false); }); }
  }, []); // eslint-disable-line
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setErr(null);
    try { const r = await login(email, password); nav(r.password_change_required ? "/change-password" : "/"); } catch (ex) { setErr(ex.message); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen grid place-items-center relative">
      <div className="cx-mesh-bg"><div className="cx-mesh-blob cx-mesh-blob-1" /><div className="cx-mesh-blob cx-mesh-blob-2" /><div className="cx-mesh-blob cx-mesh-blob-3" /></div>
      <form onSubmit={submit} className="cx-card cx-card-static cx-glass relative z-10 w-[min(420px,92vw)] p-8 space-y-5" data-testid="login-form">
        <div className="flex items-center gap-3">
          <BrandMark size={40} testid="login-brand-mark" />
          <div>
            <div className="cx-gradient-text text-2xl font-bold tracking-tight">CoreX</div>
            <div className="text-xs text-cx-muted">Sovereign LLM control plane</div>
          </div>
        </div>
        <div><Label htmlFor="email">Email</Label><Input id="email" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email" /></div>
        <div><Label htmlFor="password">Password</Label><Input id="password" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password" /></div>
        {err && <div className="cx-form-error" data-testid="login-error">{err}</div>}
        <Button type="submit" className="w-full justify-center" disabled={busy} data-testid="login-submit">{busy ? "Signing in…" : "Sign in"}</Button>
        {sso?.enabled && (<>
          <div className="flex items-center gap-3 text-[11px] text-cx-muted"><div className="h-px flex-1 bg-cx-border" />or<div className="h-px flex-1 bg-cx-border" /></div>
          <a className="cx-btn cx-btn-secondary w-full justify-center" href={`${window.location.origin}/api${sso.login_url.replace(/^\/api/, "")}?next=/`} data-testid="login-sso-btn"><KeyRound size={14} /> Continue with {sso.provider_label}</a>
        </>)}
        <p className="text-xs text-cx-muted text-center">Accounts are created by an administrator{sso?.enabled ? " or provisioned through SSO" : ""}.</p>
      </form>
    </div>
  );
}
